// extracted by mini-css-extract-plugin
export default {"premium":"PremiumIndication_premium__evHAS"};